export let OSS = "http://cdnprinttool.xingyebao.com/ksPrintTool/images"
